import { bindEvents, getPseudoProperty, offset } from '../../assets/js/helpers';

import AnimationController from '../../assets/js/controller/animation';


export const selector = 'wrapper-sticky-side';

export default class WrapperStickySide {

	constructor(section) {
		this.el = {
			section,
			content: section.querySelector(`.${selector}__content-column`),
			fixed: section.querySelector(`.${selector}__fixed`),
			cursors: section.querySelectorAll(`.${selector}__fixed [data-cursor-layer]`)
		};

		this.state = null;

		this.offset = 0;
		this.height = 0;
		this.contentHeight = 0;

		this.position = 0;

		this.animation = null;

		this.events = bindEvents(this);

		this.addEventListeners();
		this.checkState();
		this.measure();
	}

	checkState() {
		this.state = getPseudoProperty(this.el.section, 'content');
		if (this.state === 'sticky') {
			this.start();
		} else {
			this.pause();
			this.el.fixed.style.transform = '';
		}
	}

	measure() {
		this.offset = offset.top(this.el.content) - 120;
		this.height = this.el.content.offsetHeight;
		this.contentHeight = this.el.fixed.offsetHeight;
	}

	update(position) {
		const min = 0;
		const max = this.height - this.contentHeight;
		let p = Math.round(position.current - this.offset);
		if (p < min) p = min;
		if (p > max) p = max;
		if (p !== this.position) {
			this.position = p;
			return true;
		}
	}

	render() {
		this.el.fixed.style.transform = `translate3d(0,${this.position}px,0)`;
		for (const c of this.el.cursors) c.dataset.cursorOffset = this.position;
	}

	start() {
		if (!this.animation) {
			this.animation = AnimationController.set({
				update: this.update.bind(this),
				render: this.render.bind(this)
			}, 'sticky wrapper');
		}
	}

	pause() {
		if (this.animation) {
			AnimationController.clear(this.animation);
			this.animation = null;
		}
	}

	_onWindowLoad() {
		this.checkState();
		this.measure();
	}

	_onWindowResize() {
		this.checkState();
		this.measure();
	}

	addEventListeners() {
		window.addEventListener('load', this.events._onWindowLoad);
		window.addEventListener('resize', this.events._onWindowResize);
	}

	removeEventListeners() {
		window.removeEventListener('load', this.events._onWindowLoad);
		window.removeEventListener('resize', this.events._onWindowResize);
	}

	destroy() {
		this.pause();
		this.removeEventListeners();
	}

}
